Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GeneralObserver", {
  enumerable: true,
  get: function get() {
    return _generalObserver.GeneralObserver;
  }
});
var _generalObserver = require("./general-observer");